import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AppTranslateModule } from '@core/app-translate.module';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';

import { FormAutocompleteComponent } from './form-autocomplete.component';

@NgModule({
  declarations: [FormAutocompleteComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    AppTranslateModule,
    FormErrorModule,
  ],
  exports: [FormAutocompleteComponent],
})
export class FormAutocompleteModule {}
